

export enum JobStatusEnum {
    OPEN = 'OPEN',
    INPROGRESS = 'IN_PROGRESS',
    DONE = 'DONE',
    FAILED = 'FAILED',
}